import { constants } from "./module";

export function stepsSlider() {
    let $parentSection = $(".steps-section");
    let $win = $(window);
    let initGlobalFunc = function () {

        let $slider = $(".steps-list");
        let $sliderNav = $(".steps-nav");
        let $bgItems = $(".step-item-bg");
        let navList;
        let navTrack;

        let recalcHeight = function (collection) {
            let height = 0;

            for (let i = 0; i < collection.length; i++) {
                if (i < 5) {
                    height += $(collection[i]).height();
                }
            }

            return height;
        };

        let initStepSliders = function () {
            $slider.slick({
                dots: false,
                arrows: false,
                infinite: false,
                fade: true,
                slidesToShow: 1,
                asNavFor: $sliderNav,
                adaptiveHeight: true,
                responsive: [
                    {
                        breakpoint: 744,
                        settings: {
                            adaptiveHeight: true,
                        }
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            adaptiveHeight: false,
                        }
                    },
                ]
            });

            $sliderNav.slick({
                dots: false,
                arrows: false,
                infinite: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                asNavFor: $slider,
                focusOnSelect: true,
                mobileFirst: true,
                responsive: [
                    {
                        breakpoint: 744,
                        settings: {
                            vertical: true,
                            slidesToShow: 6,
                            verticalSwiping: true,
                            slidesToScroll: 1,
                        }
                    },
                ]
            }).on("beforeChange", function (event, slick, currentSlide, nextSlide) {
                $bgItems.removeClass("show-img");
                $($bgItems[nextSlide]).addClass("show-img");

                $($sliderNav.find(".slick-slide")[currentSlide]).removeClass("active");

                setTimeout(() => {
                    $($sliderNav.find(".slick-slide")[nextSlide]).addClass("active");
                },0);

                if (currentSlide > nextSlide) {
                    $sliderNav.find(".slick-slide").removeClass("inactive");
                    $sliderNav.find(".slick-current").prevAll().addClass("inactive");
                } else {
                    $($sliderNav.find(".slick-slide")[nextSlide]).prevAll().addClass("inactive");
                }
            });

            if ($(window).width() >= 744) {

                navList = $sliderNav.find(".slick-list");
                navTrack = $sliderNav.find(".slick-track");

                navTrack.addClass("static");
                navList.addClass("auto-height");

                setTimeout(() => {
                    navList.css({
                        "height": recalcHeight($sliderNav.find(".slick-slide")) + "px",
                    });

                    navTrack.css({
                        "height": recalcHeight($sliderNav.find(".slick-slide")) + "px",
                    });
                },300);
            }
        };

        initStepSliders();

        if (constants.isInViewport($sliderNav, 0)) {
            $sliderNav.addClass("set-active-el");
            $($sliderNav.find(".slick-slide")[0]).addClass("active");
        }

        $(window).on("scroll", function () {
            if (constants.isInViewport($sliderNav, 0) && !$sliderNav.hasClass("set-active-el")) {
                $sliderNav.addClass("set-active-el");
                $($sliderNav.find(".slick-slide")[0]).addClass("active");
            }
        });

        $(window).on("resize", function () {
            if ($(window).width() >= 744) {
                navList = $sliderNav.find(".slick-list");
                navTrack = $sliderNav.find(".slick-track");
                setTimeout(() => {
                    navList.css({
                        "height": recalcHeight($sliderNav.find(".slick-slide")) + "px",
                    });
    
                    navTrack.css({
                        "height": recalcHeight($sliderNav.find(".slick-slide")) + "px",
                    });
                },50);
            }
        });
    }

    if ($parentSection.offset().top - $win.scrollTop() < 400) {
        initGlobalFunc();
        $parentSection.addClass("slider-init");
    }

    $win.on("scroll", function() {
        if ($parentSection.offset().top - $win.scrollTop() < 400 && !$parentSection.hasClass("slider-init")) {
            initGlobalFunc();
            $parentSection.addClass("slider-init");
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/stepsSlider.js